const Taxi = (state) => state.Taxi
const Voucher = (state) => state.Voucher
const taxiCompanies = (state) => state.taxiCompanies

export default {
  Taxi,
  Voucher,
  taxiCompanies
}
